import React, { useState, useEffect } from "react";
import { Control, actions } from "react-redux-form";
import { Button, Card, Col, Row, Table, DropdownItem, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { compose, withHandlers, withPropsOnChange } from "recompose";
import {
  FormGroup,
  DatePicker,
  SubmitButton,
  withLocalForm,
} from "components/common";
import Select from "react-select";
import { Trans, withTranslation } from "react-i18next";
import { formatXeroDate } from "services/util";
import { invoiceBulkPost } from "components/common/ZatcaSendInvoice";
import { useBaseModal } from "services";
import { SelectedItemsDisplay } from "components/common/ZatcaSelected";
import { isNumber } from "pages/Settings";
import withDocumentRenderer from "components/DocumentRenderer/withDocumentRenderer";
import BulkCreditNoteDocument from "components/documents/BulkCreditNoteDocument";


const DownloadButton = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `Invoices_set.pdf`
    ),
})(({ DownloadDocument, DocumentRenderer, item, disabled, selectedOrganisation, validation, setDownloadHandler, EmailDocument }) => (
  <div>
    <DownloadDocument disabled={disabled} selectedOrganisation={selectedOrganisation} validation={validation} setDownloadHandler={setDownloadHandler} item={item} />
    {item && (
      <EmailDocument className="ml-3" disabled={disabled} type="BULK_INVOICES" selectedOrganisation={selectedOrganisation} validation={validation} setDownloadHandler={setDownloadHandler} item={item} />
    )}
    <DocumentRenderer component={BulkCreditNoteDocument} selectedOrganisation={selectedOrganisation} />
  </div>
));

export const Search = ({
  LocalForm,
  handleSubmit,
  searchWithinOptions,
  handleClear,
  useSimpleType,
  selectedItems,
  creditNote = false,
  selectedOrganisation,
  isPayable,
  setSelectedDocType,
  t,
  status,
}) => {

  const isZatcaSubscribed = selectedOrganisation.onboarding_date

  const type = creditNote ? "CreditNote" : "Invoice"

  const [invoiceSDKZatca, setSDKZatcaData] = useState(null);
  const [callbackFunc, setCallbackFunc] = useState();
  const [setZatcaModal, ZatcaToggle, ZatcaModal] = useBaseModal();


  const docType = creditNote ? "creditnote" : "invoice"
  const clearanceStatus = useSimpleType ? "1" : "0";
  const invoiceType = useSimpleType ? "simplified" : "standard";
  const formattedType = invoiceType.charAt(0).toUpperCase() + invoiceType.slice(1) + ` Tax ${type}`

  const setDownloadHandler = (func) => {
    setCallbackFunc(() => func);
  }


  useEffect(() => {
    const items = selectedItems;

    const mapItemToMappedData = (item) => {
      if (creditNote) {
        return invoiceBulkPost(item, docType, clearanceStatus, invoiceType, item?.Allocations?.[0]?.Invoice?.InvoiceNumber || item.AllocationInvoice);
      } else {
        return invoiceBulkPost(item, docType, clearanceStatus, invoiceType);
      }
    };

    const mappedDatas = items?.map(mapItemToMappedData);

    setSDKZatcaData(mappedDatas);

  }, [selectedItems, docType, clearanceStatus, invoiceType]);

  return (
    <LocalForm onSubmit={handleSubmit}>
      <div className="d-inline-block account-receivable-search">
        <Row className="small">
          <Col xs="auto" >
            <FormGroup
              label="Enter Number, Reference or Contact"
              className="text-nowrap"
            >
              <Control.text className="form-control" model=".description" />
            </FormGroup>
          </Col>
          <Col xs="auto" style={{ width: "150px" }} className="my-1">
            <FormGroup
              label="Search Within"
              addControlClass={false}
              className="text-nowrap"
            >
              <Control.text
                component={Select}
                style={{ minWidth: '8rem', backgroundColor: '#F4F7FE' }}
                model=".searchWithin"
                simpleValue
                clearable={false}
                options={searchWithinOptions}
              />
            </FormGroup>
          </Col>
          <Col xs="auto" style={{ width: "150px" }} className="my-1">
            <FormGroup label="Start Date" className="text-nowrap">
              <DatePicker
                className="form-control form-control-sm"
                model=".startDate"
              />
            </FormGroup>
          </Col>
          <Col xs="auto" style={{ width: "150px" }} className="my-1">
            <FormGroup label="End Date" className="text-nowrap">
              <DatePicker
                className="form-control form-control-sm"
                model=".endDate"
              />
            </FormGroup>
          </Col>
          {!isPayable &&isZatcaSubscribed && (status === "PAID" || status === "AUTHORISED" || status === "PAID,AUTHORISED") && <Col xs="3" className="my-1">
            <FormGroup label="Zatca Status" className="text-nowrap" addControlClass={false}>
              <Control.text
                component={Select}
                style={{ minWidth: '8rem', backgroundColor: '#F4F7FE' }}
                model=".zatca_status"
                simpleValue
                clearable={false}
                options={[
                  {label: t('Reported'), value:'reported'},
                  {label: t('Failed'), value:'failed'},
                  {label: t('Non Reported'), value:'unreported'},
                ]}
              />
            </FormGroup>
          </Col>}
          {!isPayable && <Col xs="3" className="my-1">
            <FormGroup label="Document Type" className="text-nowrap" addControlClass={false}>
              <Control.text
                component={Select}
                style={{ minWidth: '8rem', backgroundColor: '#F4F7FE' }}
                model=".docType"
                simpleValue
                clearable={true}
                searchable={false}
                onChange={(v) => setSelectedDocType(v || null)}
                options={[
                  { label: t('Simplified'), value: 'simplified' },
                  { label: t('Standard'), value: 'standard' },
                  { label: t('Undefined'), value: 'undefined' },
                ]}
              />
            </FormGroup>
          </Col>}
          <Col xs="auto" className="d-flex align-items-end my-1">
            <FormGroup addControlClass={false}>
              <FormGroup label="Unsent Only" check>
                <Control.checkbox model=".unsentOnly" />
              </FormGroup>
              <FormGroup label="Include Deleted & Voided" check>
                <Control.checkbox model=".includeDeletedAndVoided" />
              </FormGroup>
            </FormGroup>
          </Col>
          <Col className="col-auto d-flex align-items-end my-1">
            <div className="mb-2 d-flex justify-content-end">
              <SubmitButton className="btn-sm mx-0">Search</SubmitButton>
              <Button className="btn-sm btn-clear btn-danger" onClick={handleClear} style={{ color: '#fff' }}>
                <Trans>Clear</Trans>
              </Button>
              {!!selectedItems?.length && (
                <>
                  {isZatcaSubscribed && ['AUTHORISED', 'PAID'].includes(status) &&
                    <Button disabled={selectedItems?.length === 0} className="btn-sm btn-clear" onClick={() => setZatcaModal(true)} style={{ color: '#fff' }}>
                      <Trans>Send To Zatca</Trans>
                    </Button>
                  }
                  <div className="ml-2">
                    <DownloadButton selectedOrganisation={selectedOrganisation} disabled={selectedItems?.length === 0} validation={() => true} setDownloadHandler={setDownloadHandler} item={selectedItems} />
                  </div>
                </>
              )}
              <ZatcaModal title={(`Send ${docType.charAt(0).toUpperCase() + docType.slice(1)}s To Zatca`)} size="lg">
                <SelectedItemsDisplay
                  invoiceSDKZatca={invoiceSDKZatca?.filter((invoice) => !(invoice.Reporting?.reported || invoice.Reporting?.cleared))}
                  setSDKZatcaData={setSDKZatcaData}
                  docType={docType}
                  formattedType={formattedType}
                  setZatcaModal={setZatcaModal}
                  useSimpleType={useSimpleType}
                  t={t}
                />
              </ZatcaModal>
            </div>
          </Col>

        </Row>

      </div>
    </LocalForm>
  )
};

export const enhance = compose(
  withLocalForm({
    initialState: {
      description: "",
      searchWithin: "transactiondate",
      status: "",
      startDate: null,
      endDate: null,
      unsentOnly: false,
      includeDeletedAndVoided: false,
    },
  }),
  withTranslation(),
  withPropsOnChange(["language"], ({ t, invoice }) => {
    return {
      searchWithinOptions: [
        {
          label: t("Date"),
          value: "transactiondate",
        },
        ...(invoice
          ? [
            {
              label: t("Due Date"),
              value: "duedate",
            },
          ]
          : []),
        ...(invoice
          ? [
            {
              label: t("Any date"),
              value: "any",
            },
          ]
          : []),
      ],
    };
  }),
  withHandlers({
    handleSubmit: ({selectedOrganisation, ...props}) => (search) => {
      const items = [];
      const wpItems = {};
      if (search.description) {
        const d = search.description.replace(/"/g, "").toLowerCase();
        const args = [
          props.invoice ? "InvoiceNumber" : "CreditNoteNumber",
          "Reference",
          "Contact.Name",
        ]
          .map((v) => `(${v} != null AND ${v}.ToLower().Contains("${d}"))`)
          .join(" OR ");
        let term = args
        if (isNumber(d.replace(/,/g, ''))) {
          term = `(${args} OR Total=${parseFloat(d.replace(/,/g, ''))} OR RemainingCredit=${parseFloat(d.replace(/,/g, ''))})`
        }
        items.push(term);
        wpItems.search = d;
      }

      if (search.startDate || search.endDate) {
        switch (search.searchWithin) {
          case "any":
            if (search.startDate) {
              items.push(
                `(Date>=${formatXeroDate(
                  search.startDate
                )} OR DueDate>=${formatXeroDate(search.startDate)})`
              );
              wpItems.AnyDate__gte = search.startDate;
            }
            if (search.endDate) {
              items.push(
                `(Date<=${formatXeroDate(
                  search.endDate
                )} OR DueDate<=${formatXeroDate(search.endDate)})`
              );
              wpItems.AnyDate__lte = search.endDate;
            }
            break;
          case "transactiondate":
            if (search.startDate) {
              items.push(`Date>=${formatXeroDate(search.startDate)}`);
              wpItems.Date__gte = search.startDate;
            }
            if (search.endDate) {
              items.push(`Date<=${formatXeroDate(search.endDate)}`);
              wpItems.Date__lte = search.endDate;
            }
            break;
          case "duedate":
            if (search.startDate) {
              items.push(`DueDate>=${formatXeroDate(search.startDate)}`);
              wpItems.DueDate__gte = search.startDate;
            }
            if (search.endDate) {
              items.push(`DueDate<=${formatXeroDate(search.endDate)}`);
              wpItems.DueDate__lte = search.endDate;
            }
            break;
          default:
            break;
        }
      }

      if (search.unsentOnly) {
        items.push("SentToContact!=true");
        wpItems.SentToContact = false;
      }
      if (props.invoice) {
        items.push(`Type="ACCREC"`);
        wpItems.Type = "ACCREC";
      } else {
        items.push(`Type="${props.payable ? "ACCPAYCREDIT" : "ACCRECCREDIT"}"`);
        wpItems.Type = props.payable ? "ACCPAYCREDIT" : "ACCRECCREDIT";
      }

      if (search.zatca_status){
        if (search.zatca_status === 'reported'){
          items.push(`(Reference != null AND Reference.ToLower().Contains("zatca-reported") AND Date >= DateTime(${selectedOrganisation.onboarding_date}))`)
        }else if (search.zatca_status === 'failed'){
          items.push(`(Reference != null AND Reference.ToLower().Contains("zatca-rejected") AND Date >= DateTime(${selectedOrganisation.onboarding_date}))`)
        }else if (search.zatca_status === 'unreported'){
          items.push(`(Reference != null AND !Reference.ToLower().Contains("zatca-reported") AND Date >= DateTime(${selectedOrganisation.onboarding_date}))`) //weird but it works
        }
        
        if (selectedOrganisation.pos_contacts_ids) {
          const contactIds = selectedOrganisation.pos_contacts_ids?.split(',') || []
          const filterStrings = contactIds.map(contactId => `Contact.ContactID!=GUID("${contactId}")`);
          items.push(`(` + filterStrings.join(" AND ") + ')')
        }
      }

      let statuses = (props.status || "").split(",");

      if (search.includeDeletedAndVoided) {
        statuses = [...statuses, "VOIDED", "DELETED"];
      }
      wpItems.Statuses = statuses.join(",");
      statuses = statuses.map((i) => `Status="${i}"`).join(" OR ");
      items.push(`(${statuses})`);

      props.onFiltersChanged({
        raw: items.length ? items.join(" AND ") : undefined,
        ...wpItems,
      });
    },
    handleClear:
      ({ dispatch, onFiltersChanged }) =>
        () => {
          dispatch(actions.reset("local"));
          onFiltersChanged(null);
        },
  })
);

export default enhance(Search);
